/* eslint react/no-children-prop: 0 */
import React, { useEffect } from 'react'
import { includes } from 'libraries/lodash'
import { useDispatch, useSelector } from 'react-redux'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { observePageState, updatePageState } from 'front-end-core/services/PageStateService'
import useObservable from 'front-end-core/hooks/useObservable'
import { requestFolders } from 'services/LegislationService'
import selectLegislationFoldersMap from 'redux/selectors/selectLegislationFoldersMap'
import { setLegislationFolders } from 'redux/actions'
import Error from 'components/shared/Error'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Heading from './Heading'

export default ({ aol, query }) => {
  const folders = useObservable(requestFolders(aol), RESPONSE_PENDING)

  return (
    <ResponseConsumer
      content={() => <LegCategoriesMenu query={query} folders={folders} />}
      response={folders}
      skeleton='legislation-accordion'
    />
  )
}

const LegCategoriesMenu = ({ aol, folders, query: { name: folderName } }) => {
  const expandedSection = useObservable(observePageState('expandedSection'))
  const foldersMap = useSelector(selectLegislationFoldersMap)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      setLegislationFolders(folders)
    )
  }, [folders])

  if (!foldersMap) return null

  let categories = foldersMap.get(folderName)
  const archiveIndex = categories.findIndex(item => includes(item.name.toLowerCase(), 'archive'))
  if (archiveIndex !== -1) {
    const _categories = categories.filter(item => !includes(item.name.toLowerCase(), 'archive'))
    _categories.push(categories[archiveIndex])
    categories = _categories
  }

  const toggleExpandedSection = (id) => {
    updatePageState({ expandedSection: expandedSection !== id ? id : null })
  }

  return (
    <div className='bg-ghost-grey w-100'>
      <div className='layout-width-constraint'>
        <section className='bg-white pt7 pb6'>
          <span className='f3 b pl6'>{folderName}</span>
        </section>
        {!categories
          ? <Error title='No content' />
          : (
            <ul className='bg-white list-reset pa0 mt0'>
              {categories.map((section, index) =>
                <Heading
                  key={index}
                  id={index}
                  name={section.name}
                  children={section.legislation}
                  sectionId={folderName}
                  expanded={expandedSection === section.name}
                  toggleExpandedSection={() => toggleExpandedSection(section.name)}
                />
              )}
            </ul>
            )}
      </div>
    </div>
  )
}
